import {
  CREATE_EXHIBITION_IMAGE_REQUEST,
  CREATE_EXHIBITION_IMAGE_SUCCESS,
  CREATE_EXHIBITION_IMAGE_FAILURE,

  UPDATE_EXHIBITION_IMAGE_REQUEST,
  UPDATE_EXHIBITION_IMAGE_SUCCESS,
  UPDATE_EXHIBITION_IMAGE_FAILURE,

  DELETE_EXHIBITION_IMAGE_REQUEST,
  DELETE_EXHIBITION_IMAGE_SUCCESS,
  DELETE_EXHIBITION_IMAGE_FAILURE,
} from "../actions/types";

import ResponseService from "../../utils/ResponseService";
import ApplicationError from "../../utils/ApplicationError";

const initialState = {
  image: undefined,
  error: ApplicationError.buildDefault(),
  isFetching: false,
  ...ResponseService.defaultPaginationMetaData(),
};

const imagesReducer = (state = initialState, action) => {
  switch (action.type) {
    // Create
    case CREATE_EXHIBITION_IMAGE_REQUEST:
      return { ...state, isFetching: true };
    case CREATE_EXHIBITION_IMAGE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        image: action.payload,
        error: ApplicationError.buildDefault(),
      };
    case CREATE_EXHIBITION_IMAGE_FAILURE:
      return { ...state, isFetching: false, error: action.payload };

    // Update
    case UPDATE_EXHIBITION_IMAGE_REQUEST:
      return { ...state, isFetching: true };
    case UPDATE_EXHIBITION_IMAGE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        image: action.payload,
        error: ApplicationError.buildDefault(),
      };
    case UPDATE_EXHIBITION_IMAGE_FAILURE:
      return { ...state, isFetching: false, error: action.payload };

    // Delete
    case DELETE_EXHIBITION_IMAGE_REQUEST:
      return { ...state, isFetching: true };
    case DELETE_EXHIBITION_IMAGE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: ApplicationError.buildDefault(),
      };
    case DELETE_EXHIBITION_IMAGE_FAILURE:
      return { ...state, isFetching: false, error: action.payload };

    default:
      return state;
  }
};

export default imagesReducer;
